<script setup lang="ts" generic="T extends { id: string | number }">
import DRDisplayList from "../UI/items/DRDisplayList.vue";

withDefaults(
  defineProps<{
    label?: string;
    itemKey?: (item: T) => string | number;
    items?: T[];
    emptyText?: string;
    loading?: boolean;
  }>(),
  {
    emptyText: "Vide",
    loading: false,
  }
);
</script>

<template>
  <div class=" ">
    <div class="h4 pb-2">{{ label }}</div>

    <DRDisplayList
      :data="items"
      :loading="loading"
      key-index="id"
      :min-width="250"
    >
      <template #item="{ item, display }">
        <slot name="item" :item="item" :display="display"></slot>
      </template>
      <template #empty>
        <div>
          <div class="text-grey fw-normal">
            <slot name="empty"> </slot>
            <template v-if="!$slots.empty">
              <span>{{ emptyText }}</span>
            </template>
          </div>
        </div>
      </template>
    </DRDisplayList>
  </div>
</template>
